import { createInstance } from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";

// Create separate instances for different projects
export const investorExchangeAmplitude = createInstance();
export const investorAmplitude = createInstance();

// Common initialization function
const initializeAmplitudeInstance = (
  instance: ReturnType<typeof createInstance>,
  apiKey: string | undefined,
  deviceId?: string
) => {
  if (!apiKey) {
    console.error("Amplitude API key is not defined");
    return false;
  }

  try {
    // Initialize with default tracking disabled
    instance.init(apiKey, deviceId, {
      defaultTracking: {
        pageViews: false,
        sessions: true,
        formInteractions: false,
        fileDownloads: false
      }
    });

    const newDeviceId = instance.getDeviceId();
    if (newDeviceId) {
      localStorage.setItem("amplitudeDeviceId", newDeviceId);
    }

    instance.add(
      sessionReplayPlugin({
        sampleRate: 1,
        deviceId: newDeviceId
      })
    );

    return true;
  } catch (error) {
    console.error("Failed to initialize Amplitude:", error);
    return false;
  }
};

// Initialize both instances
export const isInvestorExchangeInitialized = initializeAmplitudeInstance(
  investorExchangeAmplitude,
  process.env.REACT_APP_INV_EXCHANGE_AMPLITUDE_KEY,
  localStorage.getItem("amplitudeDeviceId") || undefined
);

export const isInvestorInitialized = initializeAmplitudeInstance(
  investorAmplitude,
  process.env.REACT_APP_AMPLITUDE_KEY,
  localStorage.getItem("amplitudeDeviceId") || undefined
); 